export default __webpack_public_path__ + "static/media/gigglimac.b2ea4e8b.png";